import React from 'react';
import * as Icons from 'lucide-react';
import { keyAreas } from '../mock';

const KeyAreas = () => {
  return (
    <section className="relative py-24 lg:py-36 bg-paper overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="gold-divider"></span>
              <span className="font-mono-label text-gold-dark">The Framework</span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-[3.4rem] leading-[1.05] text-ink">
              Want your business <span className="italic text-gold-dark">100% </span>compliant? Master these three.
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="font-sans-body text-lg text-muted-kmh leading-relaxed">
              The KMH framework distils two decades of advisory practice into a triad every leader can act on — today.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line">
          {keyAreas.map((k) => {
            const I = Icons[k.icon] || Icons.Sparkles;
            return (
              <div key={k.title} className="group relative bg-paper hover:bg-ivory p-10 lg:p-12 card-lift">
                <div className="flex items-center justify-between">
                  <span className="font-serif-display text-6xl text-gold/30 group-hover:text-gold">{k.number}</span>
                  <I className="w-10 h-10 text-ink group-hover:text-gold-dark" strokeWidth={1.2} />
                </div>
                <h3 className="font-serif-display text-3xl text-ink mt-10">{k.title}</h3>
                <p className="font-sans-body text-base text-muted-kmh leading-relaxed mt-4">{k.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default KeyAreas;
